import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/af-loading.svg'


const _hoisted_1 = {
  key: 0,
  class: "tonibart_route-loader",
  role: "status",
  "aria-label": "A carregar"
}

import { useRouteLoading } from "@/composables/useRouteLoading";


export default /*@__PURE__*/_defineComponent({
  __name: 'RouteLoader',
  setup(__props) {

const { isLoading } = useRouteLoading();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "tonibart-route-loader-fade" }, {
    default: _withCtx(() => [
      (_unref(isLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "tonibart_route-loader_bar" }, null, -1),
            _createElementVNode("img", {
              class: "tonibart_route-loader_spinner",
              src: _imports_0,
              alt: "",
              width: "70",
              height: "40"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})